import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { AuthGuard } from "./components/router/AuthGuard";
import { AuthProvider } from "./contexts/AuthContext";

import AboutLayout from "./components/layouts/AboutLayout/AboutLayout";
import AboutUsPage from "./pages/about/AboutUs";
import ContactPage from "./pages/about/Contact";
import LegalPage from "./pages/about/Legal";
import TermsOfServicePage from "./pages/about/TermsOfService";
import SecurityPracticesPage from "./pages/about/SecurityPractices";
import FileRetentionPolicyPage from "./pages/about/FileRetentionPolicy";
import AcceptableUsePolicyPage from "./pages/about/AcceptableUsePolicy";
import SubprocessorsPage from "./pages/about/Subprocessors";
import CopyrightNoticePage from "./pages/about/CopyrightNotice";
import PaperlessPolicyPage from "./pages/about/PaperlessPolicy";
import DMCAPolicyPage from "./pages/about/DMCAPolicy";
import GDPRNoticePage from "./pages/about/GDPRNotice";
import PrivacyPolicyPage from "./pages/about/PrivacyPolicy";


import WizardPage from "./pages/wizard";

//Dashboard pages
import GradingPage from "./pages/grading";
import MainLayout from "./components/layouts/main/MainLayout/MainLayout";
import ClassesPage from "./pages/classes";
import AnswerSheetsPage from "./pages/answer_sheets";
import GradingScalesPage from "./pages/grading_scales";
import AssessmentsPage from "./pages/assessments";
import AddToGradingPage from "./pages/add_to_grading";
import UploadAnswerSheetsPage from "./pages/upload_answer_sheets";
import GradingAssessmentPage from "./pages/grading_assessment";
import ClassPage from "./pages/class";
import StudentPage from "./pages/student";
import AssessmentPage from "./pages/assessment";



// Error pages
const Error404Page = React.lazy(() => import('./pages/error/Error404Page'));

const href = window.location.href;
function Loading() {
    return <h2>🌀 Loading...</h2>;
}
export const AppRouter: React.FC = () => {
    if (href.includes("about.qa.omrquiz.app") || href.includes("about.omrquiz.app")) {
        //if (href.includes("/")) {
        return (
            <Suspense fallback={<Loading />}>
            <Routes >
                <Route path={"/"} element={<AboutLayout />} >
                    <Route path={"/"} element={<AboutUsPage />} />
                    <Route path={"/contact"} element={<ContactPage />} />
                    <Route path={"/legal"} element={<LegalPage />} />
                    <Route path={"/legal/tos"} element={<TermsOfServicePage />} />
                    <Route path={"/legal/security"} element={<SecurityPracticesPage />} />
                    <Route path={"/legal/file-retention-policy"} element={<FileRetentionPolicyPage />} />
                    <Route path={"/legal/acceptable-use"} element={<AcceptableUsePolicyPage />} />
                    <Route path={"/legal/subprocessors"} element={<SubprocessorsPage />} />
                    <Route path={"/legal/copyright-notice"} element={<CopyrightNoticePage />} />
                    <Route path={"/legal/paperless-policy"} element={<PaperlessPolicyPage />} />
                    <Route path={"/legal/dmca-policy"} element={<DMCAPolicyPage />} />
                    <Route path={"/legal/gdpr"} element={<GDPRNoticePage />} />
                    <Route path={"/legal/privacy-policy"} element={<PrivacyPolicyPage />} />
                </Route>
            </Routes>
            </Suspense>
        );
    }
    else if (href.includes("panel.qa.omrquiz.app") || href.includes("panel.omrquiz.app")) {
        //else if (href.includes("/")) {
        return (
                <AuthProvider>
                <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path={"/"} element={<MainLayout />}>
                        {/* Wizard - доступен БЕЗ авторизации */}
                        <Route index element={<WizardPage />} />
                        
                        {/* Все остальные страницы требуют авторизацию */}
                        <Route path={"/my-classes"} element={<AuthGuard><ClassesPage /></AuthGuard>} />
                        <Route path={"/class/:className"} element={<AuthGuard><ClassPage /></AuthGuard>} />
                        <Route path={"/class/:className/:studentId"} element={<AuthGuard><StudentPage /></AuthGuard>} />
                        <Route path={"/answer-sheets"} element={<AuthGuard><AnswerSheetsPage /></AuthGuard>} />
                        <Route path={"/grading-scales"} element={<AuthGuard><GradingScalesPage /></AuthGuard>} />
                        <Route path={"/assessments"} element={<AuthGuard><AssessmentsPage /></AuthGuard>} />
                        <Route path={"/assessment/:assessmentName"} element={<AuthGuard><AssessmentPage /></AuthGuard>} />
                        <Route path={"/grading"} element={<AuthGuard><GradingPage /></AuthGuard>} />
                        <Route path={"/grading-assessment"} element={<AuthGuard><GradingAssessmentPage /></AuthGuard>} />
                        <Route path={"/add-to-grading"} element={<AuthGuard><AddToGradingPage /></AuthGuard>} />
                        <Route path={"/upload-answer-sheets"} element={<AuthGuard><UploadAnswerSheetsPage /></AuthGuard>} />
                    <Route path="*" element={<Error404Page />} />
                    <Route path="*" element={<div>500</div>} />
                </Route>
                <Route path={"/:locale/"} element={<MainLayout />}>
                        {/* Wizard - доступен БЕЗ авторизации */}
                        <Route index element={<WizardPage />} />
                        
                        {/* Все остальные страницы требуют авторизацию */}
                        <Route path={"my-classes"} element={<AuthGuard><ClassesPage /></AuthGuard>} />
                        <Route path={"class/:className"} element={<AuthGuard><ClassPage /></AuthGuard>} />
                       <Route path={"class/:className/:studentId"} element={<AuthGuard><StudentPage /></AuthGuard>} />
                        <Route path={"answer-sheets"} element={<AuthGuard><AnswerSheetsPage /></AuthGuard>} />
                        <Route path={"grading-scales"} element={<AuthGuard><GradingScalesPage /></AuthGuard>} />
                        <Route path={"assessments"} element={<AuthGuard><AssessmentsPage /></AuthGuard>} />
                        <Route path={"assessment/:assessmentName"} element={<AuthGuard><AssessmentPage /></AuthGuard>} />
                        <Route path={"grading"} element={<AuthGuard><GradingPage /></AuthGuard>} />
                        <Route path={"grading-assessment"} element={<AuthGuard><GradingAssessmentPage /></AuthGuard>} />
                        <Route path={"add-to-grading"} element={<AuthGuard><AddToGradingPage /></AuthGuard>} />
                        <Route path={"upload-answer-sheets"} element={<AuthGuard><UploadAnswerSheetsPage /></AuthGuard>} />
                    </Route>
                    <Route path="*" element={<Error404Page />} />
                    <Route path="*" element={<div>500</div>} />
            </Routes>
            </Suspense>
            </AuthProvider>
        );
    }
    else {
        return (
            <Suspense fallback={<Loading />}>
            <Routes>
                <Route path={"/"} element={<WizardPage />} />
                <Route path={"/:locale/"} element={<WizardPage />} />
            </Routes>
            </Suspense>
        );
    }
};